import gql from 'graphql-tag';

export const DeleteParticipantDocument = gql`
  mutation DeleteParticipantDocument(
    $organizationId: ID!
    $participantId: ID!
    $participantDocumentId: ID!
  ) {
    deleteParticipantDocument(
      organizationId: $organizationId
      participantId: $participantId
      participantDocumentId: $participantDocumentId
    ) {
      id
    }
  }
`;
